module.exports = __webpack_public_path__ + "static/img/2-18-错发退货退款添加商品.96fffa9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/jushuitan/ppt/2-18-错发退货退款添加商品.png
// module id = 1354
// module chunks = 0